import { render, staticRenderFns } from "./jianyanService.vue?vue&type=template&id=65f0a43c&scoped=true"
import script from "./jianyanService.vue?vue&type=script&lang=js"
export * from "./jianyanService.vue?vue&type=script&lang=js"
import style0 from "./jianyanService.vue?vue&type=style&index=0&id=65f0a43c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f0a43c",
  null
  
)

export default component.exports